import { createFileRoute } from '@tanstack/react-router';
import { ImportacaoNfePage } from '@/features/importacao-nfe/page/ImportacaoNfePage';

export const Route = createFileRoute('/a/compra/importacao-nfe')({
    component: ImportacaoNfePage,
});
